import {useCallback, useEffect, useMemo} from "react";
import {defaultTQC2060_R01Filter, useTQC2060_R01Store} from "./Store_TQC2060_R01";
import useUiuxStore from "src/store/useUiuxStore";
import {downloadSettingExcel} from "src/utils/blob/blobUtil";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import {useCommonCodeStore} from "src/store/useCommonCodeStore";
import {useLoadingSpinnerStore} from "src/store/util/loadingSpinnerUtil";
import {refetchUpdateList} from "src/utils/axios/reFetch";
import {validateString} from "src/utils/string/stringUtil";
import {showSuccess, ShowSuccessFetch, showWarning} from "src/utils/toast/toastUtil";
import {
    createTQC2060_R01,
    deleteTQC2060_R01,
    downloadExcel_TQC2060_R01,
    getTQC2060_R01AllCount,
    getTQC2060_R01One,
    getTQC2060_R01Search,
    patchTQC2060_R01,
    printTQC2060_R01
} from "./Api_TQC2060_R01";
import {useQzPrint} from "src/hooks/useQzPrint";
import qz from "qz-tray";
import {defaultTQC2060_R01DtlDto, defaultTQC2060_R01HdrDto, TQC2060_R01Dto, TQC2060_R01DetailDto, TQC2060_R01HeaderDto} from "./Dto_TQC2060_R01";
import {AgGridReact} from "ag-grid-react";
import {fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler} from "src/utils/grid/GridHandlerContent";
import {validateEmployeeCd} from "src/utils/grid/GridValidateContent";
import {DateRange} from "react-day-picker";
import {useCommonCodeValidate} from "src/utils/commonCode/CommonCodeValidateContext";
import {
	buildCommonCodeRequirements,
	TQC2060_R01_HEADER_ROW_VALIDATE,
} from "src/utils/commonCode/commonCodeRequirementConfig";

interface Props {
	gridRef: React.RefObject<AgGridReact<TQC2060_R01HeaderDto> | null>;
	containerRef: React.RefObject<HTMLDivElement | null>;
}

export const Content_TQC2060_R01 = (props: Props) => {

	const {
		gridRef,
	} = props;

	useFetchActionbarAuth("TQC2060_R01");
	const { compCdList, carModelList, employeeCdList, equipmentCdList, platingTypeList } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { printPdfFromBlob } = useQzPrint();

	
	const { 
			TQC2060_R01List, setTQC2060_R01List, 
			selectedTQC2060_R01,  setSelectedTQC2060_R01, 
			editTQC2060_R01, setEditTQC2060_R01, 
			setTQC2060_R01DetailList, setDeletedTQC2060_R01DetailList,
			setOriginalTQC2060_R01DetailList,
			setPrevSampleCount, setIsEditing,
			setAllCount,
			detailFetchTrigger, setDetailFetchTrigger,
			initData,
			setScrollTop, setDetailScrollTop,
		} = useTQC2060_R01Store();

	const { 
		TQC2060_R01Filter,
		TQC2060_R01PastFilter, setTQC2060_R01PastFilter,
	} = useTQC2060_R01Store();
	const { setMessage } = useUiuxStore();

	const handleExcelClick = useCallback(async () => {
		setLoadingSpinner(true);

		const { } = fetchFilterConfig(
			TQC2060_R01Filter,
			TQC2060_R01PastFilter,
			defaultTQC2060_R01Filter,
			TQC2060_R01List.length
		);

        const response = await downloadExcel_TQC2060_R01(getParams(TQC2060_R01Filter));

		downloadSettingExcel({ responseData: response.data.data, fileName: '시험성적결과 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [TQC2060_R01PastFilter,TQC2060_R01Filter, TQC2060_R01List, setLoadingSpinner]);

	const handlePrintClick = useCallback(async () => {
		if (!selectedTQC2060_R01) {
			showWarning('인쇄할 시험 결과를 선택하세요.');
			return;
		}

		setLoadingSpinner(true);
		try {
			const response = await printTQC2060_R01(selectedTQC2060_R01.testResultNo);
			const blob = new Blob([response.data], { type: 'application/pdf' });

			if (qz.websocket.isActive()) {
				const ok = await printPdfFromBlob(blob, 'report1');
				if (ok) {
					showSuccess('시험성적서가 인쇄되었습니다.');
				} else {
					const fileURL = URL.createObjectURL(blob);
					const win = window.open(fileURL, '_blank');
					if (win) win.addEventListener('load', () => win.print());
					showWarning('QZ로 출력할 수 없어 브라우저 인쇄 창을 띄웁니다.');
				}
			} else {
				const fileURL = URL.createObjectURL(blob);
				window.open(fileURL, '_blank');
				showSuccess('시험성적서 PDF를 새 탭에서 열었습니다.');
			}
		} catch (error) {
			console.error('인쇄 실패:', error);
			showWarning('시험성적서 인쇄에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [selectedTQC2060_R01, printPdfFromBlob, setLoadingSpinner]);

    const getParams = (filter: { 
        compCd: string, 
        testDt: DateRange | undefined,
        empNo: string, 
        carModel: string, 
        equipmentCd: string 
    }) => {
        const from = filter.testDt?.from ? new Date(filter.testDt.from) : undefined;
        const to = filter.testDt?.to ? new Date(filter.testDt.to) : undefined;
        const format = (d?: Date) => d ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}` : '';
        return {
            compCd: filter.compCd,
            startDate: format(from),
            endDate: format(to),
            empNo: filter.empNo,
            carModel: filter.carModel,
            equipmentCd: filter.equipmentCd,
            listLength: 0
        };
    }

	const renewalAllCount = useCallback(async () => {
		const response = await getTQC2060_R01AllCount(getParams(TQC2060_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [TQC2060_R01Filter, setAllCount])

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);

		const { isDefaultFilter, isDefaultPastFilter } = fetchFilterConfig(
			TQC2060_R01Filter,
			TQC2060_R01PastFilter,
			defaultTQC2060_R01Filter,
			TQC2060_R01List.length
		);

        const response = await getTQC2060_R01Search(getParams(TQC2060_R01Filter));
		let newList = [...TQC2060_R01List ]
		newList = fetchDataSetHandler( //newList 내용을 DtoList에 등록
			isDefaultFilter, isDefaultPastFilter,
			response.data.data as TQC2060_R01HeaderDto[],
			TQC2060_R01List, setTQC2060_R01List,
		);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedTQC2060_R01,
				() => true,// () => !newList.find(value => value.itemCd === selectedTQC2060_R01?.itemCd)
			);
			setTQC2060_R01PastFilter(TQC2060_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		} else {
			showWarning('조회된 데이터가 없습니다.');
			await handleCreateClick();
		}
		setLoadingSpinner(false);

		return response.data.data;
	}, [TQC2060_R01Filter, TQC2060_R01List, gridRef, editTQC2060_R01, setTQC2060_R01List, setSelectedTQC2060_R01, setScrollTop, setDetailScrollTop])

	const useEquipmentCdList = useMemo(() => {

		return equipmentCdList.filter(equipment => equipment.equipmentCd
			&& equipment.equipmentType === 'TESTER' //테스트기기만 필터링
		);
	}, [equipmentCdList]);

	const defaultTQC2060_R01HeaderRow = useCallback(() => {
		return {
			...defaultTQC2060_R01HdrDto,
			compCd: compCdList[0]?.compCd ?? '',
			carModel: carModelList[0]?.minorCd ?? '',
			equipmentCd: useEquipmentCdList[0]?.equipmentCd ?? '',
			platingType: platingTypeList[0]?.minorCd ?? '',
			sampleCount: 1,
			inserted: true,
		}
	}, [compCdList, carModelList, useEquipmentCdList, platingTypeList]);

	const fetchOne = useCallback(async () => {
		if (!detailFetchTrigger) return;
		if (!selectedTQC2060_R01) return;

		const response = await getTQC2060_R01One(selectedTQC2060_R01.testResultNo);
		const apiData = response.data.data;

		//  1단계: API 응답의 testDetails를 TQC2060_R01DetailList로 변환 (단일 소스 원칙)
		if (apiData.testDetails && apiData.testDetails.length > 0) {
			// 자동완성 옵션 생성 (차종, 품목 정보 기반)
			const carModel = apiData.carModel || '';
			const itemNm = apiData.itemNm || '';
			const itemNo = apiData.itemNo || '';
			const carModelInfo = useCommonCodeStore.getState().carModelList?.find(item => item.minorCd === carModel);
			const carModelName = carModelInfo?.codeNm || carModel;
			
			const sampleOptions = [];
			if (carModel && carModelName && itemNm) {
				sampleOptions.push(`${carModel} ${carModelName} ${itemNm}`);
			}
			if (carModel && carModelName && itemNo) {
				sampleOptions.push(`${carModel} ${carModelName} ${itemNo}`);
			}
			const autoCompletedValue = sampleOptions.length > 0 ? sampleOptions[0] : '';

			// testDetails를 TQC2060_R01DetailList로 변환
			const detailList = apiData.testDetails.map((detail: TQC2060_R01DetailDto, index: number) => ({
				...detail,
				inserted: false,  //  저장된 데이터는 신규 행이 아님
			    isModified: false,  //  저장된 데이터는 수정되지 않음
				autoCompletedSampleInfo: detail.autoCompletedSampleInfo || autoCompletedValue,
				sampleInfo: detail.sampleInfo || detail.autoCompletedSampleInfo || autoCompletedValue,
			}));
			
			setTQC2060_R01DetailList(detailList);
			setOriginalTQC2060_R01DetailList(detailList);
		} else {
			// testDetails가 없으면 빈 리스트로 설정
			setTQC2060_R01DetailList([]);
			setOriginalTQC2060_R01DetailList([]);
		}

		setDetailFetchTrigger(false);
		setEditTQC2060_R01({
			...defaultTQC2060_R01HeaderRow(),
			...apiData,
		});
	}, [defaultTQC2060_R01HeaderRow, selectedTQC2060_R01, setEditTQC2060_R01, setTQC2060_R01DetailList, setOriginalTQC2060_R01DetailList, detailFetchTrigger, setDetailFetchTrigger])

	// Info 저장 전 유효성 검사
    const validateInsertData = useCallback((data: TQC2060_R01HeaderDto | null): { isValid: boolean; message?: string } => {
        if (!data) return { isValid: false, message: '시험 정보를 선택하세요.' };

        if (!validateString(data.testNm)) return { isValid: false, message: '시험명을 입력하세요.' };
        if (!validateString(data.itemNo) || !validateString(data.itemNm)) return { isValid: false, message: '품목코드를 선택하세요.' };
        if (!validateString(data.empNo) || !validateString(data.empNm)) return { isValid: false, message: '시험자를 선택하세요.' };
        if (!validateString(data.compCd)) return { isValid: false, message: '사업장을 선택하세요.' };
		if (!validateString(data.equipmentCd)) return { isValid: false, message: '시험기기를 선택하세요.' };
		if (!validateString(data.platingType)) return { isValid: false, message: '도금구분을 선택하세요.' };
		const platingTypeCode = platingTypeList.find((code) => code.minorCd === data.platingType);
		if (!platingTypeCode) {
			return { isValid: false, message: '등록되지 않은 도금구분입니다.' };
		}
		const minimumHoursText = platingTypeCode.ref04 || '';
		const minimumHoursMatch = minimumHoursText.match(/\d+/);
		if (!minimumHoursMatch) {
			return { isValid: false, message: '도금구분 공통코드의 참조4에서 최소 시험시간을 확인할 수 없습니다.' };
		}
		const minimumHours = Number(minimumHoursMatch[0]);

        if (!validateEmployeeCd(data.empNo, employeeCdList)) {
            return {
                isValid: false,
                message: '시험자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'
            };
        }

        if (!validateString(data.testFrdt)) return { isValid: false, message: '시험 시작일시를 선택하세요.' };
        if (!validateString(data.testTodt)) return { isValid: false, message: '시험 종료일시를 선택하세요.' };

        try {
            const from = new Date(data.testFrdt);
            const to = new Date(data.testTodt);

            if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) {
                return { isValid: false, message: '시험 기간 형식이 올바르지 않습니다.' };
            }

            if (from > to) {
                return { isValid: false, message: '시험 시작일시는 종료일시보다 이전이어야 합니다.' };
            }

			const minimumMinutes = minimumHours * 60;
			const testMinutes = (to.getTime() - from.getTime()) / (60 * 1000);
			if (testMinutes < minimumMinutes) {
				return {
					isValid: false,
					message: `${platingTypeCode.codeNm} 시험시간은 ${minimumHoursText}이어야 합니다.`,
				};
			}
        } catch {
            return { isValid: false, message: '시험 기간 처리 중 오류가 발생했습니다.' };
        }

        if ((data.sampleCount ?? 0) <= 0) {
            return { isValid: false, message: '시료수를 1 이상으로 입력하세요.' };
        }

        const storeState = useTQC2060_R01Store.getState();
        const currentDetailList = storeState.TQC2060_R01DetailList || [];
        const currentDeletedList = storeState.deletedTQC2060_R01DetailList || [];

        const deletedSet = new Set(currentDeletedList.map(v => String(v)));
        const activeDetails = currentDetailList.filter(d => !deletedSet.has(String(d.valueIndex)));

        if (activeDetails.length !== data.sampleCount) {
            return {
                isValid: false,
                message: `시료수(${data.sampleCount})와 디테일 행 수(${activeDetails.length})가 일치하지 않습니다.`
            };
        }

        const missing = activeDetails.filter(d => !validateString(d.sampleInfo) || !validateString(d.testValue));

        if (missing.length > 0) {
            return { isValid: false, message: '모든 디테일 행의 시험결과를 입력하세요.' };
        }

        return { isValid: true };
	}, [employeeCdList, platingTypeList]);


	const initContainerData = useCallback(() => {
		initData();
	}, [initData]);




	const handleCreateClick = useCallback(async () => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(TQC2060_R01_HEADER_ROW_VALIDATE, {
				compCdList,
				carModelList,
				equipmentCdList: useEquipmentCdList,
			}),
		);
		if (!commonResult.valid) return;

		setSelectedTQC2060_R01(undefined);
		setEditTQC2060_R01(defaultTQC2060_R01HeaderRow());
		setTQC2060_R01DetailList([{...defaultTQC2060_R01DtlDto, inserted: true}]);
		setOriginalTQC2060_R01DetailList([]);
		setDeletedTQC2060_R01DetailList([]);
		setPrevSampleCount(undefined);
		setIsEditing(false);
	}, [compCdList, carModelList, useEquipmentCdList, validateCommonCodeLists, setSelectedTQC2060_R01, setEditTQC2060_R01, setTQC2060_R01DetailList, setOriginalTQC2060_R01DetailList, setDeletedTQC2060_R01DetailList, setPrevSampleCount, setIsEditing, defaultTQC2060_R01HeaderRow]);

    const handleDeleteClick = useCallback(async () => {
        if (!selectedTQC2060_R01) {
            showWarning('선택된 품목이 없습니다.'); return;
        }
        if (window.confirm('정말로 삭제하시겠습니까?')) {
            await deleteTQC2060_R01(selectedTQC2060_R01.testResultNo);
            await refetchUpdateList('delete', selectedTQC2060_R01, selectedTQC2060_R01, 'testResultNo', TQC2060_R01List, setTQC2060_R01List);
            await handleCreateClick();
            showSuccess(`${selectedTQC2060_R01.testResultNo} 시험 삭제가 완료되었습니다.`)
        }

    }, [ TQC2060_R01List,
        handleCreateClick,
        selectedTQC2060_R01,
        setTQC2060_R01List,]);

	const handleSaveClick = useCallback(async () => {
        if (!editTQC2060_R01) { 
            showWarning("시험 정보를 선택하세요."); 
            return; 
        }

		// 저장 전 유효성 검사
		const validation = validateInsertData(editTQC2060_R01);
		if (!validation.isValid) {
			if (validation.message) showWarning(validation.message);
			return;
		}


        // 저장 직전 UI에서 직접 값 보정 (드롭다운이 렌더만 되고 상태가 비어있는 경우 대비)
        const carModelSelect = document.querySelector('select[name="carModel"]') as HTMLSelectElement | null;
        const equipmentSelect = document.querySelector('select[name="equipmentCd"]') as HTMLSelectElement | null;

        const uiCarModel = carModelSelect?.value || '';
        const uiEquipmentCd = equipmentSelect?.value || '';
        const uiEquipmentNm = equipmentSelect?.selectedOptions?.[0]?.text || '';

        //  저장 시 최신 디테일 데이터를 testDetails로 포함
        // TQC2060_R01DetailList를 단일 소스로 사용하므로, 저장 시 명시적으로 testDetails에 포함
        // 백엔드가 testDetails로 받도록 설정되어 있으므로 testDetails로 전송
        const storeState = useTQC2060_R01Store.getState();
        const currentDetailList = storeState.TQC2060_R01DetailList || [];
        const currentDeletedList = storeState.deletedTQC2060_R01DetailList || [];
        
        // 삭제된 행을 제외한 활성 디테일 리스트 생성
        const deletedSet = new Set(currentDeletedList.map(v => String(v)));
        const activeDetailList = currentDetailList.filter(d => !deletedSet.has(String(d.valueIndex)));

        const headerData: TQC2060_R01HeaderDto = {
            ...editTQC2060_R01,
            carModel: editTQC2060_R01.carModel || uiCarModel,
            equipmentCd: editTQC2060_R01.equipmentCd || uiEquipmentCd,
            equipmentNm: editTQC2060_R01.equipmentNm || uiEquipmentNm,
        };
        const payload: TQC2060_R01Dto = {
            tqcTestHeaderDto: headerData,
            tqcTestDetailDtoList: activeDetailList,
        };


        let processName = '';
        let responseData: TQC2060_R01HeaderDto | undefined = undefined;
        try {
            if (selectedTQC2060_R01) {
                processName = 'patch';
                const response = await patchTQC2060_R01(payload);
                if (response?.data) {
                    if (response.data.successFlag) {
                        if (!response.data.data) {
                            showWarning('저장 후 응답 데이터가 유효하지 않습니다.');
                            return;
                        }
                        responseData = response.data.data;
                        showSuccess(`${headerData.testResultNo} 시험 수정이 완료되었습니다.`);
                        setMessage(`${headerData.testResultNo} 시험 수정이 완료되었습니다.`);
                    } else {
                        return;
                    }
                }
            } else {
                processName = 'post';
                const response = await createTQC2060_R01(payload);
                if (response?.data) {
                    if (response.data.successFlag) {
                        if (response.data.data) {
                            responseData = response.data.data;
                            showSuccess(`${responseData.testResultNo} 시험 등록이 완료되었습니다.`);
                            setMessage(`${responseData.testResultNo} 시험 등록이 완료되었습니다.`);
                        } else {
                            // 서버 응답이 없으면 재조회
                            showSuccess('시험 등록이 완료되었습니다.');
                            setMessage('시험 등록이 완료되었습니다.');
                            fetchData(); // 전체 목록 재조회
                            return;
                        }
                    } else {
                        return;
                    }
                }
            }

            if (responseData) {
                // 신규 등록 시 testResultNo가 있는지 확인
                if (processName === 'post' && (!responseData.testResultNo || responseData.testResultNo === '')) {
                    console.warn('신규 등록 시 testResultNo가 없습니다. 리스트 업데이트를 건너뜁니다.');
                    showSuccess('시험 등록이 완료되었습니다.');
                    setTimeout(() => {
                        fetchData(); // 전체 목록 재조회로 문제 해결
                    }, 100);
                    return;
                }
                
				const savedHeaderData: TQC2060_R01HeaderDto = {
					...responseData,
					inserted: false,
					isModified: false,
				};
				refetchUpdateList(processName, savedHeaderData, savedHeaderData, 'testResultNo', TQC2060_R01List, setTQC2060_R01List);
				setSelectedTQC2060_R01(savedHeaderData);
            } else {
                console.error("저장 후 응답 데이터가 유효하지 않습니다.");
                showWarning("저장 후 응답 데이터가 유효하지 않습니다.");
            }

            setTimeout(() => {
                setMessage("");
            }, 5000);
        } catch (error) {
            console.error("저장 실패:", error);
            showWarning("시험 결과 저장에 실패했습니다.");
        }
	}, [validateInsertData, editTQC2060_R01, selectedTQC2060_R01, TQC2060_R01List, setTQC2060_R01List, setSelectedTQC2060_R01, setMessage, fetchData])

	//selectedTQC2060_R01 변경 시 품목 이미지 불러오기
	useEffect(() => {
		if (selectedTQC2060_R01) {
            fetchOne();
		}
	}, [fetchOne, selectedTQC2060_R01])

	return {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		useEquipmentCdList,
		defaultTQC2060_R01HeaderRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	}
}
